






























import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {DashboardFilterSchema} from '@/schema/filter/DashboardFilterSchema'
import {DashboardFilterCollection} from '@/model/filter/DashboardFilterCollection'

@Component
export default class DashboardFilter extends Vue {
  @Prop({type: Object, required: true}) filter!: DashboardFilterCollection

  schema = new DashboardFilterSchema()

  created() {
    this.applyFilter()
  }

  async applyFilter() {
    this.filter.resource = this.schema

    const promises: Array<Promise<any>> = [this.filter.yearOptions()]

    await this.$await.run('adapQuery', () => Promise.all(promises))
  }

  async submitEvent() {
    this.$emit('submit')
    await this.$await.run('adapQuery', () => this.filter.queryAsPage())
  }
}
